/** Produkt räknas som nyhet så länge nu är före new_until (satt vid skapande, typ +3 månader). */
export function isProductNew(newUntil: string | null | undefined): boolean {
  if (newUntil == null || newUntil === '') return false;
  const end = new Date(newUntil);
  if (Number.isNaN(end.getTime())) return false;
  return end.getTime() > Date.now();
}
